// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".automated-answer-loading-bar{position:relative;height:4px;width:100%;background:linear-gradient(90deg, #b8e7ff 0%, #0099ff 10%, #5c7fff 24%, #8575ff 50%, #962eff 76%, #0099ff 90%, #b8e7ff 100%);background-size:200% 100%;border-radius:2px;animation:genai-pulse 2s ease-in-out infinite}@keyframes genai-pulse{0%{background-position:0% 50%;opacity:.7}50%{background-position:100% 50%;opacity:1}100%{background-position:0% 50%;opacity:.7}}", ""]);
// Exports
module.exports = exports;
